//Note: This is a placeholder file and not yet part of the grunt build
//This file will handle all functions that deal with cookies, localStorage and similar

var custom_application_cookies = {}; //todo- store cookie function type like "functional, marketing etc
var custom_application_local_storage_keys = {}; //Note: probably should have information about the "type" of local storage, much like cookies it is subject to the same guidelines.

var cookie_whitelist;
var cookie_blacklist;

//TODO - cookies to change to localstorage
// var cookie_expire_int = 90;
// var dom_int_tooltip_cookie_name = "tooltip_closed";
// var geo_location_cookie_name = '9k8KDFG23jIT5BNmwd83jflp28fj';
// var location_cookie_name = 'L923DF8dff830dfj2ft3f82mvhao4';

function getCookieByName(cookieName) {
    //TODO
}

function ZZsetCookie(cookieName, cookieValue, expiry) {
    //TODO
}

function deleteCookieByName(cookieName) {
    //TODO
}

//Function to check if local storage is available, to be extended if the future requires a different check...
function isLocalStorageSupported() {
    return window.localStorage;
}
//Function to check if cookies are available, to be extended if the future requires a different check...
function areCookiesEnabled() {
    try {
        document.cookie = 'cookietest=1';
        var cookiesEnabled = document.cookie.indexOf('cookietest=') !== -1;
        document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
        return cookiesEnabled;
    } catch (e) {
        return false;
    }
}
//A function to migrate our custom application cookies to localStorage
function syncCookiesIntoLocalStorage() {
    //TODO - if localStorage is supported, find any pre-defined cookies and move them into it. Then delete those cookies
    //Might need to call this in functions that call "setCookie"
    if(isLocalStorageSupported()) {
        //TODO
    }
}


//NOTE: Some private browsers (Notably Safari on iOS) will throw exceptions when trying to setItem()
//so we should wrap all the functions in a try-catch instead of directly caling window.localstorage.setItem();
function setLocalStorageObject(key, object){
    //TODO(Christof): should this maybe return the object actually stored (or undefined if not stored)?
    try{
        if(isLocalStorageSupported()){
            localStorage.setItem(key, JSON.stringify(object));
            return true;
        }
    } catch(error) {
        console.error("Browser has thrown an error when trying to save to local storage :(", error);
    }
    return false;
}

function getLocalStorageObject(key){
    try{
        if(isLocalStorageSupported()){
             var retrievedObject = localStorage.getItem(key);
             return JSON.parse(retrievedObject);
        }
    } catch (error){
        console.error("Browser has thrown an error when trying to retrieve from local storage :(", error);
    }
    return;
}

function countsAsUTMField(name){
    return name.indexOf('utm_') === 0;
}

var MAX_UTM_TIMESTAMP_AGE = 60 * 60 *1000;//1hour

function __saveUTMToLocalStorage(){
    var queryString = window.location.search;

    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.utmCampaignData = Object.assign({}, userProfile.utmCampaignData);
    var utmCampaignData = userProfile.utmCampaignData;


    var urlParams = new CustomURLSearchParams(queryString);
    var currentCampaignData = {};
    var campaignKey = "";
    urlParams.forEach(function(value, key){
        if(countsAsUTMField(key)){
            currentCampaignData[key]=value;
            campaignKey += key+"_"+value;
        }
    });

    if(campaignKey){
        var currentTime = (new Date()).getTime();
        var recent = false;
        if(utmCampaignData[campaignKey]){
            for(var tindex = 0; tindex <  utmCampaignData[campaignKey].time.length; tindex++){
                if(utmCampaignData[campaignKey] && (currentTime - utmCampaignData[campaignKey].time[tindex] < MAX_UTM_TIMESTAMP_AGE )){
                    recent = true;
                }
            }
            if(!recent){
                utmCampaignData[campaignKey].time.push(currentTime);
            }
        }else{
            utmCampaignData[campaignKey] = {time: [currentTime], data:currentCampaignData};
        }
    }
    setLocalStorageObject('userProfile', userProfile);
}

function toTimeStampString(timestamp){
    var date =new Date(timestamp);
    var h = date.getHours();
    var m = date.getMinutes();
    if(h<10){
        h= "0"+h;
    }
    if(m<10){
        m="0"+m;
    }
    return date.toLocaleDateString("en-AU")+ " "+h+":"+m;
}

function __popUTMFromLocalStorage(){
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));

    var additionalProps = {timeStamp:""};

    //setup all keys we'll encounter
     for(var cindex in userProfile.utmCampaignData){
            var cdata = userProfile.utmCampaignData[cindex].data;
            for(var key in cdata){
                additionalProps[key] = "";
            }
     }

    for(var cindex in userProfile.utmCampaignData){
        var cdata = userProfile.utmCampaignData[cindex].data;
        for(var tindex =0;tindex < userProfile.utmCampaignData[cindex].time.length; tindex++){
            var ctime = toTimeStampString(userProfile.utmCampaignData[cindex].time[tindex]);

            additionalProps['timeStamp'] += ctime;

            for(var key in cdata){
                additionalProps[key] += cdata[key];
            }

            //ensure all keys have a (potentially empty!) value, this is so that all sets of values match up,
            //e.g. if utm_campaign doesn't exist for a link, the fields will still line up when comma separated
            for(var key in additionalProps){
                additionalProps[key] += ',';
            }
        }
    }

    for(var key in additionalProps){
        //remove trailing commas
        additionalProps[key] = additionalProps[key].slice(0,-1);
    }

    for(var index = 0 ; index < jotforms_to_update.length; index++){
        if(jotforms_to_update[index].utm_update){
  		    jotforms_to_update[index].props = Object.assign(jotforms_to_update[index].props,additionalProps);
  		}
  	}
    fixJotformPrepops();
}

function __saveUTMToCookies(){
    //TODO: actually implement this if we decide we want to fall back to it?
    console.error("cookies for UTM campaign tracking not yet supported!");
}

function __popUTMFromCookies(){
    //TODO: actually implement this if we decide we want to fall back to it?
    console.error("cookies for UTM campaign tracking not yet supported!");
}


var saveUTMData = function(){console.error("saveUTMData called before we've figured out whether to use localstorage or cookies!");};
var populateUTMData = function(){console.error("populateUTMData called before we've figured out whether to use localstorage or cookies!");};

$(function(){
    if(typeof window.CustomURLSearchParams === 'undefined'){
        window.CustomURLSearchParams = function(querystring){
            this.data = {};
            if(querystring.indexOf('?') == 0){
                querystring = querystring.slice(1);
            }
            var vars = querystring.split("&");
            for (var i=0;i<vars.length;i++) {
                var pair = vars[i].split("=");
                this.data[pair[0]] = decodeURIComponent(pair[1]);
            }
        };

        window.CustomURLSearchParams.prototype.forEach = function(func){
            for(var index in this.data){
                func(this.data[index], index);
            }
        }
    }

    if(isLocalStorageSupported()){
        saveUTMData = __saveUTMToLocalStorage;
        populateUTMData = __popUTMFromLocalStorage;
    }
    else if(areCookiesEnabled()){
        saveUTMData = __saveUTMToCookies;
        populateUTMData = __popUTMFromCookies;
    }
    else{
        saveUTMData = function(){console.log("Not saving UTM data as both local storage or cookies are unavailable.");};
        populateUTMData = function(){console.log("Not populating UTM data as bot local storage or cookies are unavailable.");};
    }
    //NOTE(Christof): we want to guarantee that the population runs after the save - this matters if the campaign
    //                link goes directly to the page with the form on it, as we plan to be using the cache for pages with utm_* query strings
    //                probably the querystring prepopulation code for jotforms will need to be rewritten then anyway?? ¯\_(ツ)_/¯
    RegisterPostGDPRHook(function(){saveUTMData(); populateUTMData();});


    //This is simply to separate the UTM specific functions from the user history functions
    RegisterPostGDPRHook(function(){populateUserProfileHistory();});

});

function PageVisit(pageUrl, pageTitle, tags, time) {
    this.url = pageUrl;
    this.title = pageTitle;
    this.tags = tags;
    this.time = time;
}

function populateUserProfileHistory() {
    var MAX_USER_PROFILE_HISTORY_SIZE = 100;
    var PAGE_VISITS_KEY = "pageVisits";
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.history = Object.assign({}, userProfile.history);
    var history = userProfile.history;

    var page_url = window.location.href;
    var clean_page_title = $("meta[property='page_title_clean']").prop("content");
    var page_title =  clean_page_title ? clean_page_title : document.title;
    var page_content_tags = getPageContentTags();
    var current_time = (new Date()).getTime();

    var current_page = new PageVisit(page_url, page_title, page_content_tags, current_time);

    if(history[PAGE_VISITS_KEY]) {
        history[PAGE_VISITS_KEY].unshift(current_page);
        //Prevent the array from getting too big
        if(history[PAGE_VISITS_KEY].length > MAX_USER_PROFILE_HISTORY_SIZE) {
            history[PAGE_VISITS_KEY].length = MAX_USER_PROFILE_HISTORY_SIZE;
        }
    } else {
        history[PAGE_VISITS_KEY] = [current_page];
    }
    setLocalStorageObject('userProfile', userProfile);
}

function getContentAffinitiesFromUserProfileHistory() {
    //Placeholder
}

function getUserProfileContentTags() {
    var questionnaire_tags = getUserProfileQuestionnaireTags();
    var user_profile_content_tags = [];
    if(questionnaire_tags) {
        for(var key in questionnaire_tags) {
            user_profile_content_tags.push(questionnaire_tags[key].path);
        }
    }
    return user_profile_content_tags;
}

function getUserProfileQuestionnaireTags() {
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.questionnaireTags = Object.assign({}, userProfile.questionnaireTags);
    return userProfile.questionnaireTags;
}

function saveUserProfileQuestionnaireTags(userContentTags) {
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.questionnaireTags = Object.assign({}, userProfile.questionnaireTags);
    userProfile.questionnaireTags = userContentTags;
    setLocalStorageObject('userProfile', userProfile);
}

function getUserProfileSystemLinks() {
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.systemLinks = Object.assign({}, userProfile.systemLinks);
    return userProfile.systemLinks;
}

function saveUserProfileSystemLinks(systemLinks) {
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.systemLinks = Object.assign({}, userProfile.systemLinks);
    userProfile.systemLinks = systemLinks;
    setLocalStorageObject('userProfile', userProfile);
}
